import { createContext } from 'react';

export const AuthContext = createContext({
  isLoggedIn: false,
  userId: null,
  token: null,
  fname: null,
  tokenExpirationDate: null,
  access: null,
  usageId: null,
  login: (
    uid,
    token,
    fname,
    expirationDate,
    access,
    image,
    tags,
    clientName,
    npsStatus,
    authType,
    email,
    userLanguage,
    hub
  ) => {},
  logout: (options) => {},
  tags: null,
  image: null,
  clientName: '',
  npsStatus: null,
  authType: null,
  language: null,
  isHub: false,
  fnfDisabled: false,
  tagHandler: (values) => {},
  npsStatusHandler: () => {},
  profileHandler: (profile) => {},
  languageHandler: (language) => {},
});
